import { Editor } from "@tinymce/tinymce-react";
import React, {
  useState,
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useCallback,
  act,
  useMemo,
} from "react";
import axios from "axios";
import { Button, Modal } from "antd";
import tinymce from "tinymce/tinymce";
import TreeView from "./TreeView";
import TreeViewAnt from "./TreeViewAnt";
import contentUiSkinCss from "tinymce/skins/ui/oxide/content.js";
import { serverDomain } from "./StaticVar";
import {
  editorContent,
  selectedStructure,
  setRefLength,
  setRemoveDuplicate,
} from "../reducer/slice";
import { useDispatch, useSelector } from "react-redux";
import { htmlToJSON, htmlToJsonNew, jsonToHtml } from "../Utility/htmlToJSON";
import { edit } from "react-arborist/dist/module/state/edit-slice";
import { diff_match_patch } from "diff-match-patch";
import rangy from "rangy";
import { current } from "@reduxjs/toolkit";
import { handleChange } from "../Utility/TrackChanges";
import { scanEditor } from "../Utility/scanEditor";
import {
  addReferenceTitle,
  addRefrenceOutput,
  referenceListing,
} from "../Utility/referenceListing";
import HandleCitation from "../Utility/HandleCitation";
import AddCitation from "../Utility/AddCitation";
import Styling from "../Utility/Styling";
import PopupModal from "../Utility/PopupModal";
import Citationpopup from "./Citationpopup";
import FrontMatter from "../Utility/FrontMatter";
import { LogIn, Split } from "lucide-react";
import { RenderButtons } from "../Utility/RenderButtons";
import { RefrenceForm } from "./Referrences/refrenceForm";
import SwapRefModal from "./Referrences/swapRefModal";
import {
  contribIdTagCheck,
  getAllRefLength,
  moveRefToTarget,
  swapRefsById,
} from "../Utility/RenderButtonLists";
import { DuplicateRefModal } from "./Referrences/duplicateModal";
import { addStarToAuthor } from "../Utility/FrontMatterList";
import CitationtoSupScript from "./CitationToSuperScript";
import RightPanel from "./RightPanel/RightPanel";
import Query from "./RightPanel/Query";
import { RightPanelRef } from "./RightPanel/References";
import AuthorGroup from "./FrontMatter/AuthorGroup";
import MetaData from "./RightPanel/MetaData";
import SettingsModal from "./settings/settings";
import { useConfig } from "../config";
import { useLocation, useNavigate, useParams } from "react-router";
import {
  handleCheckText,
  handleTabletoText,
  handleTexttoTable,
} from "../Utility/Algorithm";
import { toast } from "react-toastify";
import { AlgorithmModal } from "./Algorithm/algorithmModal";
import FootNoteModal from "./FootNote/FootNoteModal";
import {
  convertHypenToMinus,
  handleCreateEmptyTable,
  handleEnterInTd,
  splitTdOnBr,
} from "../Utility/tablelist";
import {
  handleDisplaytoInline,
  handleInlinetoDisplay,
  MathtoText,
  ReorderEquations,
  replaceXrefsHyphen,
  TexttoMath,
} from "../Utility/Equation";
import PanelReferenceForm from "./RightPanel/panelRefForm";
import { PanelDuplicateRef } from "./RightPanel/PanelDuplicateRef";
import { EditorShortCuts } from "./RightPanel/EditorShortcuts";
import PdfViewer from "./RightPanel/PdfView";
import Styles from "./RightPanel/Styling";
import SuperScript from "./RightPanel/SuperScript";
import { convertLatexToMathMl } from "mathlive";
import { latexToMathML, cleanLatex } from "../Utility/latextomathml";
import { tinyHeader } from "../Utility/tinyheader";
import ShowCitation from "./ShowCitation";
import { CustomstyleModel } from "../Utility/CustomstyleModel";
import { SuggestionsData } from "./styles/SuggestionsData";
// import { Customstyles } from "../components/styles/Customstyles";
import { Customstyles } from "../components/styles/Customstyles";


// import selectInStructure from "../Functions/selectInStructure";
if (typeof window !== "undefined") {
  require("tinymce/tinymce");
  require("tinymce/themes/silver");
  require("tinymce/plugins/advlist");
  require("tinymce/plugins/autolink");
  require("tinymce/plugins/lists");
  require("tinymce/plugins/link");
  require("tinymce/plugins/image");
  require("tinymce/plugins/charmap");
  require("tinymce/plugins/preview");
  require("tinymce/plugins/anchor");
  require("tinymce/plugins/searchreplace");
  require("tinymce/plugins/visualblocks");
  require("tinymce/plugins/code");
  require("tinymce/plugins/fullscreen");
  require("tinymce/plugins/insertdatetime");
  require("tinymce/plugins/media");
  require("tinymce/plugins/table");
  require("tinymce/plugins/help");
  require("tinymce/plugins/wordcount");
  require("tinymce/models/dom");
  require("tinymce/icons/default");
  require("tinymce/skins/ui/oxide/skin");
  require("tinymce/skins/ui/oxide/content.inline");
}

const Tinyeditor = forwardRef((props, ref) => {
  const { id } = useParams();
  const [editorKey, setEditorKey] = useState(0);
  const [fileId, setFileid] = useState(() => window.location.search);
  const [content, setContent] = useState("");
  const [newContent, setNewContent] = useState("");
  const [editor, setEditor] = useState();
  const [latex, setLatex] = useState();
  const [updatedMath, setUpdatedMath] = useState();
  const [curElement, setCurElement] = useState(null);
  const [open, setOpen] = useState(false);
  const [loadComplete, setLoadComplete] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("Content of the modal");
  const fileInputRef = useRef(null);
  const fileXmlRef = useRef(null);
  const editorRef = useRef(null);
  const dispatch = useDispatch();
  const [showQuery, setShowQuery] = useState(false);
  const handleQueryRef = useRef();
  const [navtreedata, setNavTreeData] = useState("");
  const [actualContent, setActualContent] = useState();
  const [corrections, setCorrections] = useState([]);
  const [user, setUser] = useState("User1");
  const [changes, setChanges] = useState([]);
  const previousContent = useRef("");
  const [showDelete, setShowDelete] = useState(false);
  const [editCitationShow, setEditCitationShow] = useState(false);
  const [deleteCitationShow, setDeleteCitationShow] = useState(false);
  const [addCitationShow, setAddCitationShow] = useState(false);
  const [currentCitation, setCurrentCitation] = useState();
  const [currentNode, setCurrentNode] = useState();
  const [initialized, setInitialized] = useState(false);
  const [show, setShow] = useState(false);
  const [currentStyle, setCurrentStyle] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showCitationModal, setShowCitationModal] = useState(false);
  const [inlineEditor, setInlineEditor] = useState(false);
  const [equationNum, setEquationNum] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [showFrontMatter, setShowFrontMatter] = useState({
    authorgrouping: false,
    affiliation: false,
    keywords: false,
  });
  const [showReference, setShowReference] = useState({
    add: {
      open: false,
      id: null,
    },
    edit: {
      open: false,
      id: null,
    },
    delete: {
      open: false,
      id: null,
    },
    swap: {
      open: false,
      edit: false,
      id: null,
    },
  });
  const removeDuplicate = useSelector((state) => state.editor.RemoveDuplicate);
  const [showDuplicate, setShowDuplicate] = useState(false);
  const [duplicateReference, setDuplicateReference] = useState([]);
  const [generatedQuery, setGeneratedQuery] = useState(null);
  const [AllQueryId, setAllQueryId] = useState([]);
  const [rightPanelOpen, setRightPanelOpen] = useState(false);
  const [rightPanelvalue, setRightPanelValue] = useState(null);
  const [showCitSupScript, setShowCitSupScript] = useState(false);
  const [metaValue, setMetaValue] = useState(null);
  const [settingConfig, setSettingConfig] = useState(false);
  const [tableOpen, setTableOpen] = useState(false);
  const [createTable, setCreateTable] = useState({
    rows: 2,
    cols: 3,
  });

  const { config } = useConfig();
  const [algorithmModal, setAlgorithmModal] = useState(false);
  const [footNote, setFootNote] = useState({
    open: false,
    type: null,
    node: null,
  });

  const [uploaded, setUploaded] = useState(false);
  const [xmlUploaded, setXmlUploaded] = useState(false);
  const [editShortCut, setEditShortCut] = useState(false);
  const [displayCitation, setDisplayCitation] = useState({
    open: false,
    element: null,
  });
  const [isCustomModalOpen, setCustomModalOpen] = useState(false);
  const [selectedStyles, setSelectedStyles] = useState([]);
  // const [anchorList, setAnchorList] = useState([]);



  const openCustomModal = () => setCustomModalOpen(true);
  const [editorInstance, setEditorInstance] = useState(null);

  const handleApplyStyles = (stylesArray) => {
    setSelectedStyles(stylesArray);
    setRightPanelOpen(true);
    setRightPanelValue("Custom styles");

    if (!editorInstance) return;

    // Remove old highlights
    const spans = editorInstance.dom.select(
      "span.highlight-degree, span.highlight-punctuation"
    );

    spans.forEach((span) => {
      const parent = span.parentNode;
      parent.replaceChild(
        document.createTextNode(span.textContent),
        span
      );
    });

    // Apply styles again
    stylesArray.forEach((styleId) => {
      const style = Customstyles[styleId];
      if (style?.execute) {
        style.execute(editorInstance);
      }
    });

    applySelectedStylesToEditor(editorInstance, stylesArray);
  };



  console.log("Selected value:", rightPanelvalue);
  const xmlTags = [
    "title1",
    "article",
    "front",
    "issue",
    "fpage",
    "lpage",
    "history",
    "heading",
    "abstract",
    "sec",
    "label",
    "fig",
    "aff",
    "author-notes",
    "pub-date",
    "volume",
    "contrib-group",
    "permissions",
    "copyright-statement",
    "copyright-year",
    "copyright-holder",
    "license",
    "license-p",
    "kwd-group",
    "body1",
    "list",
    "list-item",
    "table-wrap",
    "ack",
    "fn-group",
    "fn",
    "fn1",
    "ref-list",
    "back",
    "mixed-citation",
    "person-group",
    "string-name",
    "given-names",
    "article-title",
    "pub-id",
    "ref",
    "refoutput",
    "source1",
    "institution",
    "article-meta",
    "alt-title",
    "p",
    "contrib",
    "contrib-group",
    "contrib-id",
    "caption",
    "alternatives",
    "disp-formula",
    "inline-formula",
    "name",
    "email",
    "corresp",
    "tex-math",
    "reference-text",
    "reftitle",
    "tex-math[c-data|key]",
  ];
  const childDataRef = useRef(null);

  const menuConfig = {
    references: { title: "References", items: "insertRef deleteRef" },
    styles: {
      title: "Styles",
      items: "parastyles charstyles",
    },
    FMOptions: {
      title: "Front Matter",
      items: "Authorgroup Affiliation",
    },
    Algorithms: {
      title: "Algorithms",
      items: "TabletoText TexttoTable",
    },
    CustomStyles: {
      title: "CustomStyles",
      items: "Customstyle"
    },
    Help: {
      title: "Help",
    },
  };

  if (id === "admin") {
    menuConfig.settings = {
      title: "Settings",
      items: "openconfig",
    };
  }

  // var serverDomain;
  // try {
  //   serverDomain = "http://" + window.location.hostname + ":8888"
  // } catch (e) {
  //   console.log(e)
  // }
  const showModal = () => {
    setOpen(true);
  };

  const RightPanelClose = () => {
    setRightPanelOpen(false);
    setRightPanelValue(null);
  };
  // Inside component
  const mathFieldRef = useRef(null);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        if (mathFieldRef.current && latex !== undefined) {
          mathFieldRef.current.value = latex;
        }
      }, 0);
    }
  }, [open, latex]);

  useEffect(() => {
    if (!editor) return;
    const selectedNode = editor.selection?.getNode();

    if (selectedNode?.nodeType === 1) {
      setShowPopup(true);
    }
  }, [editor]);

  useEffect(() => {
    if (showQuery) {
      setRightPanelOpen(true);
      setRightPanelValue("query");
    } else if (!showQuery && rightPanelvalue === "query") {
      setRightPanelOpen(false);
      setRightPanelValue(null);
    }
  }, [showQuery]);

  useEffect(() => {
    if (!rightPanelOpen) {
      setShowQuery(false);
    }
  }, [rightPanelOpen]);

  const diff = new diff_match_patch();

  useImperativeHandle(ref, () => ({
    editorInst: editorRef.current,
  }));

  // MARK: Useeffect to toggle citation cross Ref -----------------------------------------------------------------------------------------------------
  useEffect(() => {
    if (editor) {
      addStarToAuthor(editor);
      dispatch(setRefLength(getAllRefLength(editor)));
      referenceListing(editor);
      scanEditor(editor)
    }
  }, [editor, initialized, actualContent]);

  useEffect(() => {
    if (config.RightPanel) {
      if (showFrontMatter.authorgrouping && metaValue !== "author") {
        setMetaValue("author");
        setRightPanelOpen(true);
        setRightPanelValue("meta");
      } else if (showFrontMatter.affiliation && metaValue !== "aff") {
        setMetaValue("aff");
        setRightPanelOpen(true);
        setRightPanelValue("meta");
      } else if (showFrontMatter.keywords && metaValue !== "keyword") {
        setMetaValue("keyword");
        setRightPanelOpen(true);
        setRightPanelValue("meta");
      } else if (
        !showFrontMatter.authorgrouping &&
        !showFrontMatter.affiliation &&
        !showFrontMatter.keywords
      ) {
        setMetaValue(null);
      }
    }
  }, [showFrontMatter]);

  useEffect(() => {
    if (removeDuplicate.show) {
      RenderButtons(
        editor,
        setShowFrontMatter,
        setShowReference,
        setShowDuplicate,
        setDuplicateReference
      );
      referenceListing(editor);
      childDataRef.current.removeQuery(removeDuplicate.id);
      dispatch(
        setRemoveDuplicate({
          show: false,
          id: null,
        })
      );

      dispatch(setRefLength(getAllRefLength(editor)));
    }
  }, [removeDuplicate.show]);

  const isAllClosed = useMemo(() => {
    return (
      !showReference.add.open &&
      !showReference.edit.open &&
      !showReference.delete.open &&
      !showReference.swap.edit
    );
  }, [showReference]);

  useEffect(() => {
    if (isAllClosed || showReference.swap.open) {
      RenderButtons(
        editor,
        setShowFrontMatter,
        setShowReference,
        setShowDuplicate,
        setDuplicateReference
      );
      setTimeout(() => {
        setShowReference((prev) => ({
          ...prev,
          swap: { open: false, edit: false, id: null },
        }));
      }, 0);
      dispatch(setRefLength(getAllRefLength(editor)));
    } else if (showReference.delete.open) {
      setShowDelete(true);
    }
    // referenceListing(editor);
  }, [isAllClosed, showReference.delete.open, showReference.swap.open]);

  useEffect(() => {
    if (showReference?.add?.open) {
      if (config.RightPanel) {
        setRightPanelValue(null);
        setRightPanelOpen(true);
        setShowDuplicate(false);
        setEditShortCut(false);
        setShow(false);
        setShowCitSupScript(false);
      }

      setShowReference((prev) => ({
        ...prev,
        edit: { open: false, id: null },
      }));
    }
  }, [showReference?.add?.open]);

  useEffect(() => {
    if (showReference?.edit?.open) {
      if (config.RightPanel) {
        setRightPanelValue(null);
        setRightPanelOpen(true);
        setShowDuplicate(false);
        setEditShortCut(false);
        setShow(false);
        setShowCitSupScript(false);
      }

      setShowReference((prev) => ({
        ...prev,
        add: { open: false, id: null },
      }));
    }
  }, [showReference?.edit?.open]);

  useEffect(() => {
    if (showDuplicate) {
      if (config.RightPanel) {
        setRightPanelValue(null);
        setRightPanelOpen(true);
        setShowReference((prev) => ({
          ...prev,
          add: {
            open: false,
            id: null,
          },
          edit: {
            open: false,
            id: null,
          },
        }));
        setEditShortCut(false);
        setShowCitSupScript(false);

        setShow(false);
      }
    }
  }, [showDuplicate]);

  useEffect(() => {
    if (rightPanelvalue) {
      setShowReference((prev) => ({
        ...prev,
        add: {
          open: false,
          id: null,
        },
        edit: {
          open: false,
          id: null,
        },
      }));
      setShowDuplicate(false);
      setEditShortCut(false);
      setShowCitSupScript(false);

      setShow(false);

      if (rightPanelvalue !== "query") {
        setShowQuery(false);
      }
    }
  }, [rightPanelvalue]);

  useEffect(() => {
    if (editor?.dom) {
      addReferenceTitle(editor);
      addRefrenceOutput(editor);
      if (childDataRef.current) {
        childDataRef.current.handleCheckQuery();
      }

      replaceXrefsHyphen(editor);
      // updateAllMathFormulas(editor);
      contribIdTagCheck(editor);
      setTimeout(() => {
        RenderButtons(
          editor,
          setShowFrontMatter,
          setShowReference,
          setShowDuplicate,
          setDuplicateReference
        );
      }, 0);
    }
  }, [editor, actualContent]);

  useEffect(() => {
    if (generatedQuery) {
      sendDataToChild();
    }
  }, [generatedQuery]);

  // const handleQueryfn = useSelector((state) => state.editor.handleQueryfn);

  // useEffect(() => {
  //   if (editor) {
  //     // handleChange(editor, diff, actualContent, user);
  //     handleChange(editor, {
  //       id: "user1",
  //       name: "John Doe",
  //       color: "#FF0000",
  //     });
  //   }
  // }, [actualContent, diff, editor, user]);

  // To update editor content based on tree change

  // useEffect(() => {
  //   if (editor) {
  //     let body = editor.getContent();
  //     let element = htmlToJsonNew(body);
  //     dispatch(editorContent({ content: body, getbody: element }));
  //   }
  // }, []);
  // useEffect(() => {
  //   if (!editor) return;

  //   const handler = () => {
  //     const element = htmlToJsonNew(editor.getBody().innerHTML);
  //     dispatch(
  //       editorContent({ content: editor.getContent(), getbody: element })
  //     );
  //     setNavTreeData(element.json);
  //   };

  //   // Trigger only when content changes
  //   editor.on("change", handler);

  //   return () => {
  //     editor.off("change", handler);
  //   };
  // }, [editor]);

  const treedata = useSelector((state) => state.editor.treecontent);

  useEffect(() => {
    if (treedata !== undefined) {
      const newXML = jsonToHtml(treedata.data[0]);

      editor.setContent(newXML);
      referenceListing(editor);
    }
  }, [treedata]);

  useEffect(() => {
    const fileParam = location.search.replace("?", "");
    if (fileParam) {
      const response = axios
        .get(serverDomain + "/get/" + fileParam)
        .then((response) => {
          setContent(response.data.xml);
          setUploaded(true);
          setEditorKey((k) => k + 1);
        });
    }
  }, [location.search]);

  // useEffect(() => {
  //   dispatch(selectedStructure({ nodeSelection }));
  // }, [nodeSelection, dispatch]);

  const handleOk = () => {
    setModalText("The modal will be closed after two seconds");
    setConfirmLoading(true);
    setTimeout(() => {
      setOpen(false);
      setConfirmLoading(false);
    }, 2000);
  };

  const handleCancel = () => {
    setOpen(false);
    setShowDelete(false);
    setEditCitationShow(false);
    setDeleteCitationShow(false);
    setAddCitationShow(false);
    setShow(false);
    setShowCitationModal(false);
    setShowFrontMatter({ authorgrouping: false, affiliation: false });
    setShowReference({
      add: {
        open: false,
        id: null,
      },
      edit: {
        open: false,
        id: null,
      },
      delete: {
        open: false,
        id: null,
      },
      swap: {
        open: false,
        edit: false,
        id: null,
      },
    });
    setUpdatedMath(null);
    setLatex(null);
    setEquationNum(null);
    setRightPanelOpen(false);
    setShowDuplicate(false);
    setEditShortCut(false);
    setShowCitSupScript(false);
  };

  const sendDataToChild = () => {
    if (childDataRef.current) {
      childDataRef.current.addQuery(generatedQuery); // Update child state directly
    }
  };

  function handleCitToSupScript() {
    setShowCitSupScript(true);
    setEditShortCut(false);
    setRightPanelOpen(true);
    setRightPanelValue(null);
    setShowDuplicate(false);
    setShow(false);
  }

  const handleDisplayCitClose = () => {
    setDisplayCitation({
      open: false,
      element: null,
    });
  };

  const handleSwap = (targetId, mode) => {
    const fromId = showReference.swap.id;

    if (mode === "swap") {
      swapRefsById(editor, fromId, targetId, setShowReference);
    } else if (mode === "move") {
      moveRefToTarget(editor, fromId, targetId, setShowReference);
    }
    setShowReference((prev) => ({
      ...prev,
      swap: {
        open: false,
        edit: false,
        id: null,
      },
    }));
  };

  const handleDupRefCancel = () => {
    setShowDuplicate(false);
  };
  const handleCitClose = () => {
    setShowCitSupScript(false);
  };

  // function customizeDiff(oldContent, newContent) {
  //   let oldtext = tokenizeText(getTextContent("I am old", oldContent));
  //   let newtext = tokenizeText(getTextContent("I am new", newContent));

  //   const deleted = oldtext.filter((word) => !newtext.includes(word));
  //   const added = newtext.filter((word) => !oldtext.includes(word));

  //   return { added, deleted };
  // }

  // function getTextContent(text, html) {
  //   const div = document.createElement("div");
  //   div.innerHTML = html;
  //   console.log(text, div.innerText.trim());

  //   return div.innerText.trim();
  // }

  // function tokenizeText(text) {
  //   return text.split(/\s+/);
  // }

  // MARK: Handle Editor Change ----------------------------------------------------------------------------------------------------------------------
  const handleEditorChange = (newCont, editor) => {
    // let changes = handleTrackChange(
    //   newContent,
    //   editor,
    //   diff_match_patch,
    //   actualContent
    // );

    // referenceListing(editor);

    // setTimeout(() => {
    //   setCorrections([...corrections, changes]);
    // }, 2000);

    // setContent(newContent);

    // let images = editor.getDoc().getElementsByTagName("img");
    // for (let image of images) {
    //   image.setAttribute("src", serverDomain + "/" + image.getAttribute("src"));
    // }
    props.setEditorReference(editor); //To set editor instance
    //     setNewContent((prev) => {
    //   if (prev === newCont) return prev; // no change
    //   return newCont; // update state
    // });

    // let element = htmlToJsonNew(editor.getBody().innerHTML);
    // dispatch(editorContent({ content: editor.getContent(), getbody: element }));
    // setNavTreeData(element.json);
    window.e = editor;
  };

  //   const handleEditorChanges = (content, editor) => {
  //   if (!selectedStyles.length) return;

  //   const newAnchorList = [];

  //   selectedStyles.forEach(styleId => {
  //     const style = Customstyles[styleId];
  //     if (style?.execute) {
  //       style.execute(editor, newAnchorList); // this will add anchor objects with markerClass spans
  //     }
  //   });

  //   setAnchorList(newAnchorList); // this will feed SuggestionsData
  // };

  function generateRandomId(prefix = "") {
    return prefix + Math.random().toString(36).substr(2, 5); // Generate a random alphanumeric ID
  }

  let typingTimeout;
  let combinedAddition = "";
  let combinedDeletion = "";
  let currentAddedId = null;
  let lastKey = null; // <-- FIXED: Declare outside so it persists
  let shouldWrap = true;

  // Track last key globally

  function setupKeydownListener(editor) {
    editor?.on("keydown", (e) => {
      lastKey = e.key;
    });
  }

  const handleTrackChange = (
    newContent,
    editor,
    diff_match_patch,
    actualContent
  ) => {
    const currentNode = editor?.selection.getNode();
    const key = currentNode?.getAttribute("key");
    if (!key) return;

    const refNode = actualContent?.querySelector(`[key="${key}"]`);
    if (!refNode) return;

    const oldText = refNode.innerText || "";

    // Clone and clean up <ins> and <del> before diffing
    const clonedNode = currentNode.cloneNode(true);
    clonedNode.querySelectorAll("ins, del").forEach((tag) => tag.remove());
    const newText = clonedNode.innerText || "";

    const dmp = new diff_match_patch();
    let diffs = dmp.diff_main(oldText, newText);
    dmp.diff_cleanupSemantic(diffs);

    let cursorIndex = 0;
    combinedAddition = "";
    combinedDeletion = "";

    diffs.forEach(([op, data]) => {
      if (op === 1) {
        combinedAddition += data;
      } else if (op === -1) {
        combinedDeletion += data;
        // Optional: Track deletions separately if needed
        insertDeletedAtPosition(
          editor,
          currentNode,
          editor.selection.getRng(),
          combinedDeletion,
          generateRandomId()
        );
      }
      if (op !== -1) {
        cursorIndex += data.length;
      }
    });

    // Only wrap inserted text if not deleting and not inside existing <ins>
    if (
      combinedAddition &&
      lastKey !== "Backspace" &&
      lastKey !== "Delete" &&
      !isInsideInsertion(editor)
      // !shouldWrap
    ) {
      const addId = currentAddedId || generateRandomId();
      wrapInsertedText(editor, combinedAddition, addId);
      currentAddedId = null;
    }
    // else if (combinedDeletion) {
    //   const delId = currentDeletedId || generateRandomId("del_");
    //   wrapDeletedText(editor, combinedDeletion, delId);
    // }

    // Reset additions and key
    combinedAddition = "";
    combinedDeletion = "";
    lastKey = null;
  };

  function isInsideInsertion(editor) {
    const selection = editor.selection;
    const container = selection.getNode();
    return container.closest("ins") !== null;
  }
  function isInsideDeletion(editor) {
    const selection = editor.selection;
    const container = selection.getNode();
    return container.closest("del") !== null;
  }

  function wrapInsertedText(editor, text, id) {
    const doc = editor.getDoc();
    const selection = editor.selection;
    let range = selection.getRng();

    // Check if inside existing <ins>
    let container = range.commonAncestorContainer;
    if (container.nodeType === Node.TEXT_NODE) container = container.parentNode;
    const existingIns = container.closest("ins");

    if (existingIns) {
      existingIns.textContent += text;
      range.setStart(existingIns, existingIns.childNodes.length);
      range.collapse(true);
      selection.setRng(range);
      return;
    }

    // Create new <ins> and replace selected text
    const ins = doc.createElement("ins");
    ins.id = id;
    ins.style.color = "green";
    ins.textContent = text;

    if (!range.collapsed) range.deleteContents();
    range.insertNode(ins);

    // Move cursor after the new <ins>
    const newRange = doc.createRange();
    newRange.setStartAfter(ins);
    newRange.collapse(true);
    selection.setRng(newRange);
  }

  let currentDeletedId = null;

  function insertDeletedAtPosition(
    editor,
    hostNode,
    cursorOffset,
    deletedText,
    deletionId
  ) {
    const doc = editor.getDoc();
    const selection = editor.selection;

    // 1. Find the exact text node and position within hostNode
    const textPosition = findTextPosition(hostNode, cursorOffset);
    if (!textPosition) return;

    // 2. Create deletion range: Ensure it does not exceed the node length
    const textNodeLength = textPosition.node.length;
    const endOffset = Math.min(
      textPosition.startOffset + deletedText.length,
      textNodeLength
    );

    // 3. Create the range to delete the text
    const deletionRange = doc.createRange();
    deletionRange.setStart(textPosition.node, textPosition.startOffset);
    deletionRange.setEnd(textPosition.node, endOffset);

    // 4. Remove the original text content (but don't update caret yet)
    deletionRange.deleteContents();

    // 5. Create <del> element with the deleted text
    const delElement = createDeletionElement(doc, deletedText, deletionId);

    // 6. Insert the <del> element in place of the deleted text
    deletionRange.insertNode(delElement);

    // 7. Clean up empty <ins> markers if necessary
    cleanupEmptyInsertions(delElement);

    // 8. After inserting the <del>, place the caret after the <del> element
    positionCursorAfter(selection, delElement);

    // 9. Ensure that the caret doesn't jump to an invalid position
    if (textPosition.node.nodeValue) {
      const newCaretPosition = textPosition.startOffset + deletedText.length;
      moveCaretToPosition(selection, textPosition.node, newCaretPosition);
    }

    currentDeletedId = deletionId;
  }

  // Helper: Find the exact text node and offsets within host node
  function findTextPosition(hostNode, targetOffset) {
    const walker = document.createTreeWalker(
      hostNode,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    let accumulatedLength = 0;
    let currentNode;

    while ((currentNode = walker.nextNode())) {
      const nodeLength = currentNode.length;

      if (accumulatedLength + nodeLength >= targetOffset) {
        return {
          node: currentNode,
          startOffset: Math.max(targetOffset - accumulatedLength, 0),
          endOffset: targetOffset - accumulatedLength,
        };
      }
      accumulatedLength += nodeLength;
    }
    return null;
  }

  // Helper: Create the <del> element with styling
  function createDeletionElement(doc, text, id) {
    const del = doc.createElement("del");
    del.setAttribute("data-deletion-id", id);
    Object.assign(del.style, {
      color: "red",
      textDecoration: "line-through",
      backgroundColor: "#ffe6e6",
    });
    del.textContent = text;
    return del;
  }

  // Helper: Remove empty <ins> markers if needed
  function cleanupEmptyInsertions(contextNode) {
    const emptyInsElements = contextNode.parentElement.querySelectorAll("ins");
    emptyInsElements.forEach((ins) => {
      if (!ins.textContent.trim()) {
        ins.parentNode?.replaceChild(document.createTextNode(""), ins);
      }
    });
  }

  // Helper: Position the caret after the deleted element
  function positionCursorAfter(selection, element) {
    const range = document.createRange();
    range.setStartAfter(element);
    range.collapse(true);
    selection.setRng(range);
  }

  // Helper: Move the caret to a specific position within the text node
  function moveCaretToPosition(selection, node, position) {
    const range = document.createRange();
    range.setStart(node, position);
    range.setEnd(node, position);
    selection.removeAllRanges();
    selection.addRange(range);
  }

  console.log(process.env.PUBLIC_URL, "prcoes");

  // MARK: handleFileChange -------------------------------------------------------------------------------------------------------------------
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    const filename = file.name.replace(/\.[^/.]+$/, "");

    editor.notificationManager.open({
      text: "File upload in progress.",
      type: "info",
    });

    try {
      const response = await axios.post(serverDomain + "/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      navigate(`${location.pathname}/?${filename}`);

      // setContent(response.data.xml);
      // setUploaded(true);
      editor.notificationManager.close();
      editor.notificationManager.open({
        text: "File upload completed.",
        type: "success",
        timeout: 5000,
      });
    } catch (error) {
      editor.notificationManager.close();
      editor.notificationManager.open({
        text: "Error uploading file, please contact dev team.",
        type: "error",
      });
      console.error("There was an error uploading the file!", error);
    }

    // const reader = new FileReader();

    // reader.onload = (e) => {
    //   const fileContent = e.target.result;
    //   setEditorKey((k) => k + 1);
    //   let element = htmlToJsonNew(fileContent);
    //   setContent(element.updatedHtml);
    //   setUploaded(true);
    // };

    // reader.readAsText(file);
  };

  // MARK:XmlFileUpload

  const handleXmlUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();

    reader.onload = (e) => {
      const fileContent = e.target.result;
      let element = htmlToJsonNew(fileContent);
      setEditorKey((k) => k + 1);
      setContent(element.updatedHtml);
      setXmlUploaded(true);
    };

    reader.readAsText(file);
  };

  const initializeEditorContent = (editorInstance) => {
    let element = htmlToJsonNew(props.content);
    setContent(element.updatedHtml);
    props.setEditorReference(editorInstance);
    handleInit(null, editorInstance);
    dispatch(
      editorContent({
        content: element.updatedHtml,
        getbody: element,
      })
    );
    setNavTreeData(element.json);
  };

  const uploadedEditorContent = (editorInstance) => {
    let element = htmlToJsonNew(content);
    setContent(element.updatedHtml);
    props.setEditorReference(editorInstance);
    handleInit(null, editorInstance);
    dispatch(
      editorContent({
        content: element.updatedHtml,
        getbody: element,
      })
    );
    setNavTreeData(element.json);
  };

  const updateMath = () => {
    // var latexHtml = convertLatexToMathMl(updatedMath, {
    //   strict: true, // avoids inferred nodes
    //   preserveSpacing: false, // removes spacing-related <mo>
    // });

    var latexHtml = latexToMathML(cleanLatex(updatedMath));

    const display = curElement?.closest("disp-formula");

    // Avoid double wrapping <math> if already wrapped
    const isAlreadyMathML = /^\s*<math[\s>]/.test(latexHtml);

    const mathContent = isAlreadyMathML
      ? latexHtml
      : `<math>${latexHtml}</math>`;

    if (curElement !== null) {
      curElement.innerHTML = mathContent;
      curElement.setAttribute("c-data", updatedMath);
    } else {
      editorRef.current.editor.execCommand(
        "mceInsertContent",
        false,
        `<tex-math>${mathContent}</tex-math>`
      );
    }

    // Set equation number if applicable
    if (display) {
      const parentElement = display.parentNode;
      const label = parentElement?.querySelector("label");
      if (label && equationNum) {
        label.innerText = `(${equationNum})`;
      } else if (label && !equationNum) {
        label.innerText = `()`;
      }
      // ReorderEquations(editor);
    }
    setEquationNum(null);
    setOpen(false);
    // setUpdatedMath(null);
    // setLatex(null)
    return;
  };

  // MARK: Select in Structure ---------------------------------------------------------------------------------------------------------------
  const selectInStructure = (editor) => {
    const selection = editor.selection?.getNode();
    // setNodeSelection(selection);
    if (selection) {
      let key = selection.getAttribute("key");
      dispatch(selectedStructure({ key: key }));
    }
  };
  // MARK: Update Math Field------------------------------------------------------------------------------------------------------
  const updateMathField = (e) => {
    setUpdatedMath(e.target.value);
    showModal();
  };

  const handleKeyDown = (e) => {
    const mf = mathFieldRef.current;
    if (!mf) return;

    if (e.key === " ") {
      e.preventDefault();
      // Insert a LaTeX non-breaking space
      mf.executeCommand("insert", "~");
    }
  };

  // MARK: Delete Reference -----------------------------------------------------------------------------------------------
  function deleteReference(node, editor) {
    if (node.tagName.toLowerCase() === "ref") {
      setShowDelete(true);
      setShowReference((prev) => ({
        ...prev,
        delete: {
          open: true,
          id: node.getAttribute("id"),
        },
      }));
    } else {
      editor?.dom.remove(editor?.selection.getNode());
    }
  }

  // MARK: Reference Delete ----------------------------------------------------------------------------------
  function referenceDelete() {
    let node = editor.dom.select(`ref[id="${showReference.delete.id}"]`)[0];
    let refId = node.getAttribute("id");
    const xrefEles = editor?.dom.select("xref") || [];
    const refCits = xrefEles.filter(
      (ele) => editor.dom.getAttrib(ele, "ref-type") === "bibr"
    );

    const selectedRefCits = refCits.filter(
      (refCit) => refCit.getAttribute("rid") === refId
    );

    editor?.dom.remove(node);

    referenceListing(editor);
    addReferenceTitle(editor);

    for (let i = 0; i < selectedRefCits.length; i++) {
      editor.dom.setHTML(selectedRefCits[i], "?");
    }

    if (childDataRef.current) {
      childDataRef.current.handleAddQuery(selectedRefCits);
    }
    setShowDelete(false);
    setShowReference((prev) => ({
      ...prev,
      delete: {
        open: false,
        id: null,
      },
    }));
  }

  // MARK: Handle Citations -----------------------------------------------------------------------------------
  function deleteCitations() {
    let node = editor?.selection.getNode();
    if (node) {
      editor?.dom.remove(node);
    }
    setDeleteCitationShow(false);
  }

  const handleCitationEdit = (node) => {
    setEditCitationShow(true);
    setCurrentNode(node);
  };

  const addCitationfn = () => {
    setAddCitationShow(true);
  };

  const handleCitationPopup = (editor) => {
    let node = editor?.selection?.getNode();
    if (node.tagName.toLowerCase() === "xref") {
      setShowCitationModal(true);
      setCurrentNode(node);
    } else {
      Modal.info({
        title: "Invalid Selection",
        content: "The selected node is not a reference.",
      });
    }
  };

  // MARK: Handle inline editor for front Matter  ----------------------------------------------------------------------------------------------
  useEffect(() => {
    if (!editor) return;

    const handler = (e) => {
      if (e && e.element) {
        addnbsp(editor);
      }
    };

    if (inlineEditor) {
      addnbsp(editor);
      editor.on("NodeChange", handler);
    } else {
      removenbsp(editor);
    }

    // Cleanup function to remove old listeners
    return () => {
      editor.off("NodeChange", handler);
    };
  }, [inlineEditor, editor]);

  const addnbsp = (editor) => {
    if (!editor?.dom) return;

    setTimeout(() => {
      const dom = editor.dom;
      const front = dom.select("front");

      if (front.length > 0) {
        const contribGroup = dom.select("contrib-group", front[0]);
        const authornotes = dom.select("author-notes", front[0]);

        if (contribGroup.length > 0) {
          findAndInsertNbsp(contribGroup[0]);
        }
        if (authornotes.length > 0) {
          findAndInsertNbsp(authornotes[0]);
        } else {
          console.log("No contrib-group found.");
        }
      } else {
        console.log("No front tag found.");
      }
    }, 0);
  };

  const findAndInsertNbsp = (parent) => {
    const children = Array.from(parent.children);

    children.forEach((child, index) => {
      if (child.nodeType === 1) {
        // ✅ Add &nbsp; before text node if not present
        if (child.firstChild && child.firstChild.nodeType === 3) {
          const text = child.firstChild.textContent;
          if (!text.startsWith("\u00A0" || " ")) {
            child.firstChild.textContent = `\u00A0${text}`;
          }
        }

        // ✅ Recurse into nested children
        findAndInsertNbsp(child);

        // ✅ Insert &nbsp; between this and the next tag, only if no text node already
        const next = child.nextSibling;
        if (child?.nextSibling?.nodeType === 1) {
          console.log(child.nextSibling);
        }

        if (next && next.nodeType === 3) {
          const between = child.nextSibling;

          if (
            !(
              between &&
              between.nodeType === 3 &&
              between.textContent === "\u00A0"
            )
          ) {
            const nbsp = document.createTextNode("\u00A0");
            child.parentNode.insertBefore(nbsp, next);
          }
        }
      }
    });

    // ✅ Add one &nbsp; after last child if none exists
    if (children.length > 0) {
      const last = children[children.length - 1];
      const afterLast = last.nextSibling;
      if (
        !(
          afterLast &&
          afterLast.nodeType === 3 &&
          afterLast.textContent === "\u00A0"
        )
      ) {
        last.parentNode.insertBefore(
          document.createTextNode("\u00A0"),
          afterLast
        );
      }
    }
  };

  const removenbsp = (editor, shouldReplace = () => true) => {
    if (!editor?.dom) return;

    setTimeout(() => {
      const dom = editor.dom;
      const front = dom.select("front");

      if (front.length > 0) {
        const contribGroup = dom.select("contrib-group", front[0]);
        const authornotes = dom.select("author-notes", front[0]);

        const processSection = (section) => {
          if (section.length > 0) {
            const walker = document.createTreeWalker(
              section[0],
              NodeFilter.SHOW_TEXT,
              null,
              false
            );

            let node;
            while ((node = walker.nextNode())) {
              if (shouldReplace(node)) {
                node.textContent = node.textContent.replace(/\u00A0/g, "");
              }
            }
          }
        };

        processSection(contribGroup);
        processSection(authornotes);
      }
    }, 0);
  };

  const removeformatting = (editor) => {
    // Get selected HTML
    const node = editor.selection.getNode();

    if (node) {
      const content = node.innerHTML;

      editor.dom.remove(node, true);

      editor.selection.collapse(false);
    }
  };

  const applySelectedStylesToEditor = (editor, selectedStyles) => {
    if (!editor || selectedStyles.length === 0) return;

    selectedStyles.forEach((styleId) => {
      const style = Customstyles[styleId];
      if (style?.execute) {
        style.execute(editor);
      }
    });
  };



  const handleEditorInit = (evt, editor) => {
    editorRef.current = editor;
    setEditorInstance(editor);

    // click events
    editor.on("click", (e) => {
      childDataRef.current?.handleEditClick?.(e);
    });

    // run on change
    editor.on("change", () => {
      applySelectedStylesToEditor(editor, selectedStyles);
    });

    // immediately apply styles to any existing content (important for XML upload)
    applySelectedStylesToEditor(editor, selectedStyles);
  };

  // MARK:Table and Text Foot-Note ----------------------------------------------------------------------

  const handleTableFootNote = (editor, node) => {
    const td = editor.dom.getParent(node, "td");
    const fn = editor.dom.getParent(node, "fn");
    if ((node.tagName.toLowerCase() === "td" || td) && !fn) {
      setFootNote({
        open: true,
        type: "table",
        node,
      });
    } else {
      toast.warn("Selection is not a Table");
    }
  };
  const handleTextFootNote = (editor, node) => {
    const td = editor.dom.getParent(node, "td");
    const fn = editor.dom.getParent(node, "fn");
    const p1 = editor.dom.getParent(node, "p");

    if (p1 && !fn) {
      setFootNote({
        open: true,
        type: "text",
        node,
      });
    } else if (fn) {
      toast.warn("Selection is already footnote");
    }
  };

  const handleInit = (evt, editor) => {
    // wait a tick so TinyMCE paints the UI
    setTimeout(() => {
      const menubar = document.querySelector(".tox-menubar");
      if (menubar && !menubar.querySelector(".custom-logo")) {
        const logo = document.createElement("img");
        logo.src = `${process.env.PUBLIC_URL + "/images/logo.svg"}`; // <-- change this
        logo.alt = "Logo";
        logo.className = "custom-logo";
        logo.style.height = "36px";
        logo.style.paddingRight = "16px";
        menubar.insertBefore(logo, menubar.firstChild);
      }
    }, 0);
  };

  //  ------------------------ MARK:Download XMl -------------------

  const downloadXML = () => {
    if (!editorRef.current) return;
    console.log(editorRef.current.editor, "editor");
    const cleanId = fileId ? fileId.replace(/^\?/, "") : "vedas";
    const xmlContent = editorRef.current.editor.getContent({ format: "raw" });

    const blob = new Blob([xmlContent], { type: "application/xml" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${cleanId}.xml`; // file name
    a.click();

    URL.revokeObjectURL(url);
  };

  // MARK: JSX Starts -------------------------------------------------------------------

  return (
    <div
      className={`relative transition-all ease-in-out duration-200 h-full flex w-full`}
    >
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
      <input
        type="file"
        ref={fileXmlRef}
        onChange={handleXmlUpload}
        style={{ display: "none" }}
      />
      <Modal
        title="Math Equation"
        open={open}
        onOk={updateMath}
        maskClosable={false}
        onCancel={() => setOpen(false)}
        zIndex={10}
      >
        <div className="flex w-full justify-end mb-4">
          <form>
            <label htmlFor="eqnumber">Equation Number :</label>
            <input
              className="border-grey ml-1 px-1 w-[50px] outline-none border"
              name="eqnumber"
              type="text"
              value={equationNum ?? ""}
              onChange={(e) => setEquationNum(e.target.value)}
            />
          </form>
        </div>

        <math-field
          ref={mathFieldRef}
          style={{ width: "100%", border: "1px solid grey", outline: "none" }}
          onInput={updateMathField}
          onKeyDown={handleKeyDown}
        />
      </Modal>

      <Modal
        title="Create Table"
        open={tableOpen}
        onOk={() => {
          if (createTable.rows && createTable.cols) {
            setTableOpen(false);
            handleCreateEmptyTable(editor, createTable.rows, createTable.cols);
          }
        }}
        maskClosable={false}
        onCancel={() => setTableOpen(false)}
        zIndex={10}
      >
        <div className="flex w-full  mb-4">
          <form className="flex flex-row w-full gap-4">
            <div className="flex items-center gap-2">
              <label htmlFor="tabnumbner">Rows :</label>
              <input
                className="border-grey ml-1 px-1 w-[50px] outline-none border"
                name="tablerow"
                type="text"
                required
                value={createTable.rows ?? ""}
                onChange={(e) =>
                  setCreateTable((prev) => ({
                    ...prev,
                    rows: parseInt(e.target.value, 10) || null, // convert to number
                  }))
                }
              />
            </div>
            <div className="flex items-center gap-2">
              <label htmlFor="tabcol">Columns :</label>
              <input
                className="border-grey ml-1 px-1 w-[50px] outline-none border"
                name="tablecol"
                type="text"
                required
                value={createTable.cols ?? ""}
                onChange={(e) =>
                  setCreateTable((prev) => ({
                    ...prev,
                    cols: parseInt(e.target.value, 10) || null,
                  }))
                }
              />
            </div>
          </form>
        </div>
      </Modal>
      {/* MARK: Editor component --------------------------------------------------------------------------------------------------------------- */}
      <Editor
        key={editorKey}
        ref={editorRef}
        contentEditable
        initialValue={content}

        // value={content}
        onFocusOut={(content, editor) => handleEditorChange(content, editor)}
        // onEditorChange={(content, editor) => handleEditorChanges(content, editor)}
        //      onEditorChange={(content, editor) => {
        //   // You can keep your existing onEditorChange handler if needed
        //   handleEditorChange(content, editor);
        // }}
        licenseKey="gpl"
        mode="exact"
        onInit={handleEditorInit}

        init={{
          promotion: false,
          branding: false,
          selector: "textarea",
          height: "100%",
          width: "100%",
          formats: {
            highlight_degree: {
              inline: "span",
              classes: "highlight-degree"
            }
          },
          // valid_elements: "[id]",
          valid_children:
            "contrib-group[contrib[name[surname given-name]]] +body[tex-math]",
          custom_elements: xmlTags.join(","),
          // extended_valid_elements : "title,title1,article,front,issue,fpage,lpage,history,abstract,sec,label,fig,aff,author-notes,pub-date,volume,contrib-group,permissions,copyright-statement,copyright-year,copyright-holder,license,license-p,kwd-group,body,list,list-item,table-wrap,ack,fn-group,fn,ref-list,back,ref-list,mixed-citation,person-group,string-name,given-names,article-title,pub-id,ref,source1",
          remove_linebreaks: false,
          extended_valid_elements: xmlTags.map((tag) => `${tag}[*]`).join(","),
          entity_encoding: "raw",
          forced_root_block: false,
          // protect: [/<\/?given-names[^>]*>/g], // valid_elements: "+@[id]",
          encoding: "xml",
          menu: menuConfig,
          whitespace_elements: "bold,italic,underline",
          // contextmenu:
          //   "link selectInStructure Citations showCitations footNote query",
          contextmenu: "Citations footNote query Equation insertTab",
          menubar:
            "logo file edit references styles FMOptions settings Algorithms CustomStyles",
          allow_script_urls: true,
          verify_html: false,
          plugins:
            "autolink lists link image charmap anchor searchreplace visualblocks code fullscreen insertdatetime media table wordcount ",
          // toolbar:
          //   "undo redo | code | insertmath | uploadDoc | query | fullscreen ",
          toolbar:
            "nodeinfo undo redo |" +
            "bold italic underline strikethrough removeformatting | " +
            // "alignleft aligncenter alignright alignjustify | " +
            // "bullist numlist outdent indent | " +

            "|code insertmath query citationtosuperscript customtable insertTableMenu | ",
          // skin_url: "/assets/libs/tinymce/skins/ui/oxide",
          content_css: [
            "/vedas/custom.css",
            `
         .highlight-degree{
        background: #fff3cd;
        border-bottom:2px solid orange;
        padding:1px;
      }

      .highlight-punctuation{
        background:#e7f3ff;
        border-bottom:2px solid #4096ff;
        padding:1px;
      }
      `
          ],
          setup: function (editor) {
            // MARK:ADD Header
            

            // MARK: button to show current node ________________________________________________________________________________________________________
            editor.ui.registry.addButton("nodeinfo", {
              text: "hheekkekkekkekke",

              tooltip: "Selected Node Info",
              class: "my-nodeinfo-btn",
              onAction: () => { },
              onSetup: function (api) {
                const redirectTags = ["p"];

                const getTargetNode = (node) => {
                  const tag = node.nodeName.toLowerCase();
                  let headingType = null;
                  const parent = node.parentNode;
                  const parentTag = parent?.nodeName.toLowerCase();
                  const parentId = parent?.getAttribute("id") || "";

                  // --- Figure captions ---
                  if (tag === "title1" && parentTag === "fig") {
                    if (/^fig-\d+$/.test(parentId)) {
                      headingType =
                        parentId.replace("fig-", "fig") + "-caption";
                    }
                    return { node: parent, headingType };
                  }

                  // ---  bold,italic ---
                  if (tag === "em") {
                    headingType = "italic";
                    return { node: parent, headingType };
                  }
                  if (tag === "strong") {
                    headingType = "bold";
                    return { node: parent, headingType };
                  }
                  // --- ack ---
                  if (tag === "p" && parentTag === "ack") {
                    headingType = "ack";
                    return { node: parent, headingType };
                  }
                  // --- Figure labels ---
                  if (tag === "label" && parentTag === "fig") {
                    if (/^fig-\d+$/.test(parentId)) {
                      headingType = parentId.replace("fig-", "fig") + "-label";
                    }
                    return { node: parent, headingType };
                  }

                  // --- Table captions ---
                  if (tag === "title1" && parentTag === "table") {
                    if (/^tbl-\d+$/.test(parentId)) {
                      headingType =
                        parentId.replace("tbl-", "table") + "-caption";
                    }
                    return { node: parent, headingType };
                  }

                  // --- Table labels ---
                  if (tag === "label" && parentTag === "table") {
                    if (/^tbl-\d+$/.test(parentId)) {
                      headingType =
                        parentId.replace("tbl-", "table") + "-label";
                    }
                    return { node: parent, headingType };
                  }

                  // --- Table-Wrap captions ---
                  if (tag === "title1" && parentTag === "table-wrap") {
                    if (/^table-\d+$/.test(parentId)) {
                      headingType =
                        parentId.replace("table-", "table") + "-caption";
                    }
                    return { node: parent, headingType };
                  }

                  // --- Table-Wrap labels ---
                  if (tag === "label" && parentTag === "table-wrap") {
                    if (/^table-\d+$/.test(parentId)) {
                      headingType =
                        parentId.replace("table-", "table") + "-label";
                    }
                    return { node: parent, headingType };
                  }

                  // --- Reference headings  ---
                  const isParentRefTitle =
                    parent &&
                    parent.getAttribute &&
                    parent.getAttribute("data-edit") === "refTitleWrapper";

                  if (tag === "title1" && isParentRefTitle) {
                    headingType = "Reference";
                    return { node: parent, headingType };
                  }
                  if (tag === "reftitle") {
                    headingType = node.textContent;
                    return { node: parent, headingType };
                  }
                  // --- Section headings & subheadings ---
                  if (tag === "title1" && parentTag === "sec") {
                    if (/^s\d+(_\d+)*$/.test(parentId)) {
                      const secNumber = parentId
                        .replace(/^s/, "")
                        .replace(/_/g, ".");
                      headingType = `sec${secNumber}-heading`;
                    }
                    return { node: parent, headingType };
                  }
                  // --- Section labels ---
                  if (tag === "label" && parentTag === "sec") {
                    if (/^s\d+(_\d+)*$/.test(parentId)) {
                      const secNumber = parentId
                        .replace(/^s/, "")
                        .replace(/_/g, ".");
                      headingType = `sec${secNumber}-label`;
                    }
                    return { node: parent, headingType };
                  }
                  if (tag === "p" && parentTag === "sec") {
                    if (/^s\d+(_\d+)*$/.test(parentId)) {
                      // Remove leading 's', replace underscores with dots, prepend 'sec'
                      const secNumber = parentId
                        .replace(/^s/, "")
                        .replace(/_/g, ".");
                      headingType = `sec${secNumber}-p`;
                    }
                    return { node: parent, headingType };
                  }

                  if (tag === "label") {
                    let formulaNode = null;

                    if (parentTag === "disp-formula") {
                      formulaNode = parent;
                    } else {
                      const prev = node.previousElementSibling;
                      if (
                        prev &&
                        prev.nodeName.toLowerCase() === "disp-formula"
                      ) {
                        formulaNode = prev;
                      }
                    }

                    if (formulaNode && formulaNode.id) {
                      const match = formulaNode.id.match(/\d+/);
                      if (match) {
                        headingType = `math-label${match[0]}`;
                        return { node: formulaNode, headingType };
                      }
                    }
                  }

                  return { node, headingType };
                };

                const updateDisplay = () => {
                  const node = editor.selection.getNode();
                  const { node: targetNode, headingType } = getTargetNode(node);

                  if (headingType) {
                    api.setText(headingType);
                  } else {
                    api.setText(targetNode.nodeName.toLowerCase());
                  }
                };

                editor.on("NodeChange", updateDisplay);

                return () => {
                  editor.off("NodeChange", updateDisplay);
                };
              },
            });

            editor.ui.registry.addMenuItem("Customstyle", {
              text: "Custom Styles1",
              onAction: () => {
                // const selectedContent = editor.selection.getContent();
                // editor.insertContent(
                //   `<span class="my-custom-style">${selectedContent}</span>`
                // );
                openCustomModal();
              },
            });

            setEditor(editor);
            setupKeydownListener(editor);
            // handleChange(editor);
            window.e = editor;
            // MARK: editor init function ------------------------------------------------------------------------------------------------------------------------
            editor.on("init", function (e) {
              setInitialized(true);
              //this gets executed AFTER TinyMCE is fully initialized
              // if (!uploaded) {
              //   let element = htmlToJsonNew(props.content);
              //   setContent(element.updatedHtml);
              //   props.setEditorReference(editor); //passing editor Instance
              //   handleInit(null, editor);
              //   dispatch(
              //     editorContent({
              //       content: element.updatedHtml,
              //       getbody: element,
              //     })
              //   );
              //   setNavTreeData(element.json);
              // }
              if (!uploaded && !xmlUploaded) {
                initializeEditorContent(editor);
              } else {
                uploadedEditorContent(editor);
              }
              // setTimeout(() => {
              //   const clonedBody = editor?.getBody()?.cloneNode(true);
              //   setActualContent(clonedBody);
              //   tinyHeader(editor);
              // }, 1000);
              const interval = setInterval(() => {
                const container = editor.getContainer?.();

                if (container) {
                  clearInterval(interval); // stop polling immediately

                  const clonedBody = editor.getBody()?.cloneNode(true);
                  setActualContent(clonedBody);
                  tinyHeader(editor);
                }
              }, 20);
            });

            editor.ui.registry.addMenuItem("deleteRef", {
              type: "menuitem",
              text: "Delete",
              onAction: function () {
                // editor.dom.remove(editor.selection.getNode());
                deleteReference(editor.selection.getNode(), editor);
              },
            });
            editor.ui.registry.addNestedMenuItem("insertRef", {
              text: "Insert",
              getSubmenuItems: () => {
                var res = [];
                var allowed_tags = [
                  { text: "Year", tag: "year" },
                  { text: "First Page", tag: "fpage" },
                  { text: "Last Page", tag: "lpage" },
                  { text: "DOI", tag: "pub-id" },
                ];
                for (var allowed_tag of allowed_tags) {
                  res.push({
                    type: "menuitem",
                    text: allowed_tag["text"],
                    tag: allowed_tag["tag"],
                    onAction: function (tag) {
                      // let el = editor.dom.create(tag, { id: 'test', 'class': 'myclass' }, 'some content');
                      // tinymce.activeEditor.selection.setNode(el);
                      editor.insertContent(`<${tag}></${tag}>`);
                    }.bind(this, allowed_tag["tag"]),
                  });
                }
                return res;
              },
            });
            editor.on("keydown", function (e) {
              const node = editor.selection.getNode();
              const td = editor.dom.getParent(node, "td");
              if (
                e.key === "Enter" &&
                node.parentNode &&
                node.parentNode.tagName.toLowerCase() === "aff"
              ) {
                e.preventDefault();
                return;
              }
              if (e.key === "Enter" && !e.shiftKey) {
                handleEnterInTd(editor, e);
              }
              // if (e.key === "Enter" && !e.shiftKey  ) {
              //   const node = editor.selection.getNode();
              //   e.preventDefault();
              //   const Pkey = generateRandomId();
              //   const p = editor.dom.create("p", { key: Pkey }, "<br>");
              //   editor.dom.insertAfter(p, node);
              //   editor.selection.setCursorLocation(p, 0);
              // }
            });

            editor.on("click", function (e) {
              //this gets executed AFTER TinyMCE is fully initialized
              if (e.target.tagName == "TEX-MATH") {
                const value = e.target.getAttribute("c-data");
                setCurElement(e.target);

                setLatex(value);
                setUpdatedMath(value);

                const parentFormula = e.target.closest("disp-formula");
                if (parentFormula && parentFormula.tagName === "DISP-FORMULA") {
                  const parent = parentFormula.parentElement;
                  const label = parent.querySelector("label");

                  if (label?.textContent?.trim()) {
                    const labelText = label.textContent.trim();
                    const match = labelText.match(/\((\d+)\)/);

                    if (match) {
                      const labelNumber = parseInt(match[1], 10);
                      setEquationNum(labelNumber);
                    }
                  }
                } else {
                  setEquationNum(null);
                }
                setTimeout(() => {
                  showModal();
                }, 10);
              } else if (e.target.getAttribute("href") !== null) {
                let targetId = e.target.getAttribute("href").replace("#", "");
                let targetElement = editor.getDoc().getElementById(targetId);
                if (targetElement !== null) {
                  // targetElement.scrollIntoView({
                  //   behavior: "smooth",
                  //   block: "start",
                  //   inline: "nearest",
                  // });
                  e.preventDefault(); // stop any default behavior
                  setDisplayCitation({
                    open: true,
                    element: targetElement,
                  });
                }
              }
            });
            // editor.ui.registry.addButton("uploadDoc", {
            //   text: null,
            //   icon: "upload",
            //   tooltip: "upload document",
            //   onAction: (_) => {
            //     if (fileInputRef.current) {
            //       fileInputRef.current.click();
            //     }
            //   },
            // });
            editor.addCommand("uploadDoc", function () {
              if (fileInputRef.current) {
                fileInputRef.current.click();
              }
            });
            editor.addCommand("uploadXML", function () {
              if (fileXmlRef.current) {
                fileXmlRef.current.click();
              }
            });
            editor.addCommand("downloadXML", function () {
              downloadXML()
            });
            editor.ui.registry.addButton("insertmath", {
              text: null,
              icon: "math-equation",
              tooltip: "math-equation",
              onAction: (_) => {
                setOpen(true);
              },
            });
            editor.ui.registry.addButton("removeformatting", {
              text: null,
              icon: "remove-formatting",
              tooltip: "clear formatting",
              onAction: (_) => {
                removeformatting(editor);
              },
            });
            editor.ui.registry.addMenuButton("Query", {
              text: null,
              icon: "Comment",
              fetch: (callback) => {
                callback([
                  {
                    type: "menuitem",
                    text: "Add Query",
                    onAction: () => {
                      childDataRef.current.handleAddQuery(); // or any function defined in this component
                    },
                  },
                  {
                    type: "menuitem",
                    text: "Show / Hide Query",
                    onAction: () => {
                      setShowQuery((prev) => !prev);
                    },
                  },
                ]);
              },
            });
            editor.ui.registry.addToggleButton("toggleInlineEditor", {
              tooltip: "Edit Inline",
              icon: "line",
              onAction: (api) => {
                const active = !api.isActive();
                api.setActive(active);
                setInlineEditor(active);
              },
              onSetup: (api) => {
                api.setActive(inlineEditor);
                return () => { };
              },
            });
            editor.ui.registry.addButton("citationtosuperscript", {
              icon: "superscript",
              tooltip: "citations to superscript",
              onAction: (_) => {
                handleCitToSupScript();
              },
            });
            editor.ui.registry.addMenuButton("customtable", {
              text: null,
              tooltip: "Table Properties",
              icon: "table",
              fetch: (callback) => {
                callback([
                  {
                    type: "menuitem",
                    text: "para to row",
                    onAction: () => {
                      const node = editor.selection.getNode();
                      const table = editor.dom.getParent(node, "table");
                      if (table?.tagName.toLowerCase() === "table") {
                        splitTdOnBr(table);
                      } else {
                        toast.warn("Please select table");
                      }
                    },
                  },
                  {
                    type: "menuitem",
                    text: "hypen to minus",
                    onAction: () => {
                      const node = editor.selection.getNode();
                      const table = editor.dom.getParent(node, "table");
                      if (table?.tagName.toLowerCase() === "table") {
                        convertHypenToMinus(editor, table);
                      } else {
                        toast.warn("Please select table");
                      }
                    },
                  },
                ]);
              },
            });

            // editor.ui.registry.addButton("shownode", {
            //   text: "Tag: -", // initial placeholder
            //   tooltip: "Current Selected Tag",
            //   onSetup: function (buttonApi) {
            //     const handler = () => {
            //       const tagName =
            //         editor.selection.getNode()?.tagName?.toLowerCase() ||
            //         "none";
            //       buttonApi.setText(`Tag: <${tagName}>`);
            //     };

            //     editor.on("NodeChange", handler);

            //     return () => {
            //       editor.off("NodeChange", handler);
            //     };
            //   },
            //   onAction: function () {
            //     // Optional: you could also alert or do something else
            //   },
            // });
            editor.ui.registry.addMenuItem("selectInStructure", {
              text: "Select In Structure",
              onAction: (_) => {
                selectInStructure(editor);
              },
            });
            editor.ui.registry.addMenuItem("showCitations", {
              text: "Show Reference",
              onAction: function () {
                handleCitationPopup(editor);
              },
            });
            editor.ui.registry.addMenuItem("query", {
              text: "Add Query",
              onAction: function () {
                childDataRef.current.handleAddQuery();
              },
            });
            editor.ui.registry.addMenuItem("insertTab", {
              text: "Insert Table",
              onAction: function () {
                setTableOpen(true);
              },
            });

            editor.ui.registry.addMenuItem("Authorgroup", {
              text: "Author Grouping",
              onAction: function () {
                setShowFrontMatter({ authorgrouping: true });
              },
            });
            editor.ui.registry.addMenuItem("Affiliation", {
              text: "Affiliation",
              onAction: function () {
                setShowFrontMatter({ affiliation: true });
              },
            });

            editor.ui.registry.addMenuItem("openconfig", {
              text: "config",
              onAction: function () {
                setSettingConfig(true);
              },
            });
            editor.ui.registry.addMenuItem("TabletoText", {
              text: "Table to Text",
              onAction: function () {
                if (editor) {
                  const promise = handleTabletoText(editor);
                  if (promise) {
                    toast.success("Table to Text Converted");
                  } else {
                    toast.warn("Selection is not a Algorithm Table");
                  }
                }
              },
            });
            editor.ui.registry.addMenuItem("TexttoTable", {
              text: "Text to Table",
              onAction: function () {
                if (editor) {
                  const response = handleCheckText(editor);
                  if (response.success && response.title) {
                    const success = handleTexttoTable(editor, null);
                    if (success) {
                      toast.success("Text to Table Algorithm Converted");
                    }
                  } else if (!response.title) {
                    setAlgorithmModal(true);
                  } else if (!response.success) {
                    toast.warn("Please Select Text");
                  }
                }
              },
            });


            // Dynamically build the context menu
            editor.ui.registry.addContextMenu("xrefMenu", {
              update: function (element) {
                // Only show the menu item if the clicked element is <xref>
                if (element && element.nodeName.toLowerCase() === "xref") {
                  return ["showCitations"];
                }

                // Return empty array to show no custom items
                return [];
              },
            });
            editor.ui.registry.addNestedMenuItem("Citations", {
              text: "Citations",
              getSubmenuItems: () => {
                let node = editor.selection.getNode();

                if (
                  node.tagName === "XREF"
                  // node.getAttribute("ref-type") === "bibr"
                ) {
                  return [
                    {
                      type: "menuitem",
                      text: "Edit Citation",
                      onAction: () => handleCitationEdit(node),
                    },
                    {
                      type: "menuitem",
                      text: "Delete Citation",
                      onAction: () => setDeleteCitationShow(true),
                    },
                    {
                      type: "menuitem",
                      text: "Add Citation",
                      onAction: () => addCitationfn(node),
                    },
                  ];
                } else {
                  return [
                    {
                      type: "menuitem",
                      text: "Add Citation",
                      onAction: () => addCitationfn(node),
                    },
                  ];
                }
              },
            });

            editor.ui.registry.addNestedMenuItem("footNote", {
              text: "Add FootNote",
              getSubmenuItems: () => {
                let node = editor.selection.getNode();

                return [
                  {
                    type: "menuitem",
                    text: "Table FootNote",
                    onAction: () => handleTableFootNote(editor, node),
                  },
                  {
                    type: "menuitem",
                    text: "Text FootNote",
                    onAction: () => handleTextFootNote(editor, node),
                  },
                ];
              },
            });

            editor.ui.registry.addNestedMenuItem("Equation", {
              text: "Equation",
              getSubmenuItems: () => {
                let node = editor.selection.getNode();

                return [
                  {
                    type: "menuitem",
                    text: "Display to Inline",
                    onAction: () => {
                      const rng = editor.selection.getRng();
                      if (rng) {
                        const selectedNode = rng.commonAncestorContainer;

                        const formulaNode =
                          selectedNode.nodeType === 1
                            ? selectedNode.closest("disp-formula")
                            : selectedNode.parentElement?.closest(
                              "disp-formula"
                            );

                        if (formulaNode) {
                          handleDisplaytoInline(editor, formulaNode);
                          toast.success("Equation changed display to inline");
                        } else {
                          toast.warn(" Selection not a Display Equation");
                        }
                      }
                    },
                  },
                  {
                    type: "menuitem",
                    text: "Inline to Display",
                    onAction: () => {
                      const rng = editor.selection.getRng();
                      if (rng) {
                        const selectedNode = rng.commonAncestorContainer;

                        const formulaNode =
                          selectedNode.nodeType === 1
                            ? selectedNode.closest("inline-formula")
                            : selectedNode.parentElement?.closest(
                              "inline-formula"
                            );

                        if (formulaNode) {
                          handleInlinetoDisplay(editor, formulaNode);
                          toast.success("Equation changed inline to display");
                        } else {
                          toast.warn("Selection Not a Inline Equation");
                        }
                      }
                    },
                  },
                  {
                    type: "menuitem",
                    text: "Text to Math",
                    onAction: () => {
                      const selectedNode = editor.selection.getNode();

                      if (
                        selectedNode.closest("disp-formula") ||
                        selectedNode.closest("inline-formula")
                      ) {
                        toast.warn("Selection is already a math.");
                        return;
                      }

                      const selectedText = editor.selection.getContent({
                        format: "text",
                      });
                      if (!selectedText.trim()) {
                        toast.warn("Please select text");
                        return;
                      }
                      TexttoMath(editor);
                    },
                  },
                  {
                    type: "menuitem",
                    text: "Math to Text",
                    onAction: () => {
                      const rng = editor.selection.getRng();
                      if (rng) {
                        const selectedNode = rng.commonAncestorContainer;

                        let formulaNode = null;

                        if (selectedNode.nodeType === 1) {
                          formulaNode =
                            selectedNode.closest("disp-formula") ||
                            selectedNode.closest("inline-formula");
                        } else if (selectedNode.parentElement) {
                          formulaNode =
                            selectedNode.parentElement.closest(
                              "disp-formula"
                            ) ||
                            selectedNode.parentElement.closest(
                              "inline-formula"
                            );
                        }

                        if (formulaNode) {
                          MathtoText(editor, formulaNode);
                        } else {
                          toast.warn("Please Select Math");
                        }
                      }
                    },
                  },
                  {
                    type: "menuitem",
                    text: "Reorder Equations",
                    onAction: () => {
                      ReorderEquations(editor);
                      toast.success("Equations Reordered");
                    },
                  },
                ];
              },
            });
            editor?.ui?.registry?.addMenuItem("parastyles", {
              type: "menuitem",
              text: "Paragraph Styles",
              onAction: () => {
                setShow(true);
                setEditShortCut(false);
                setRightPanelOpen(true);
                setRightPanelValue(null);
                setShowDuplicate(false);
                setCurrentStyle("ParaStyle");
                setShowCitSupScript(false);
              },
            });
            editor?.ui?.registry?.addMenuItem("charstyles", {
              type: "menuitem",
              text: "Character Styles",
              onAction: () => {
                setShow(true);
                setEditShortCut(false);
                setRightPanelOpen(true);
                setRightPanelValue(null);
                setShowDuplicate(false);
                setCurrentStyle("CharStyle");
                setShowCitSupScript(false);
              },
            });

            // editor.ui.registry.addButton("helping", {
            //   text: null,
            //   icon: "Help",
            //   tooltip: "Editor Shortcuts",

            //   onAction: () => {
            //     setEditShortCut(true);
            //     setRightPanelOpen(true);
            //     setRightPanelValue(null);
            //     setShowDuplicate(false);
            //     setShow(false);
            //     setShowCitSupScript(false);
            //   },
            // });

            editor.addCommand("helping", function () {
              setEditShortCut(true);
              setRightPanelOpen(true);
              setRightPanelValue(null);
              setShowDuplicate(false);
              setShow(false);
              setShowCitSupScript(false);
            });

            // MARK: Editor Shortcuts
            editor.addShortcut("alt+p", "Open paragraph styles", () => {
              setShow(true);
              setCurrentStyle("ParaStyle");
            });
            editor.addShortcut("alt+c", "Open character styles", () => {
              setShow(true);
              setCurrentStyle("CharStyle");
            });
            editor.addShortcut("alt+q", "Add Query", () => {
              childDataRef.current.handleAddQuery();
            });
            editor.addShortcut("alt+r", "remove formatting", () => {
              removeformatting(editor);
            });

            editor.addShortcut("F1", "open shortcuts", () => {
              setEditShortCut(true);
              setRightPanelOpen(true);
              setRightPanelValue(null);
              setShowDuplicate(false);
              setShow(false);
              setShowCitSupScript(false);
            });

            // Superscript
            editor.addShortcut("ctrl+shift+s", "Superscript", () => {
              editor.formatter.toggle("superscript"); // lowercase
            });

            // Subscript
            editor.addShortcut("ctrl+shift+b", "Subscript", () => {
              editor.formatter.toggle("subscript"); // lowercase
            });

            // Find Next
            editor.addShortcut("ctrl+pagedown", "Find Next", () => {
              editor.execCommand("FindNext");
            });

            // Find Previous
            editor.addShortcut("ctrl+pageup", "Find Previous", () => {
              editor.execCommand("FindPrev");
            });

            // Left single quotation mark ‘
            editor.addShortcut("alt+ctrl+5", "Left single quote", () => {
              editor.insertContent("‘");
            });

            // Left double quotation mark “
            editor.addShortcut("alt+5", "Left double quote", () => {
              editor.insertContent("“");
            });

            // Right single quotation mark ’
            editor.addShortcut("alt+ctrl+6", "Right single quote", () => {
              editor.insertContent("’");
            });

            // Right double quotation mark ”
            editor.addShortcut("alt+6", "Right double quote", () => {
              editor.insertContent("”");
            });

            // Increase Indent
            editor.addShortcut("ctrl+1", "Increase Indent", () => {
              editor.execCommand("Indent");
            });

            // Decrease Indent
            editor.addShortcut("ctrl+2", "Decrease Indent", () => {
              editor.execCommand("Outdent");
            });

            // Degree sign
            editor.addShortcut("ctrl+4", "Degree sign", () => {
              editor.insertContent("\u00B0");
            });

            // Prime
            editor.addShortcut("ctrl+5", "Prime", () => {
              editor.insertContent("\u2032");
            });

            // Double prime
            editor.addShortcut("ctrl+6", "Double prime", () => {
              editor.insertContent("\u2033");
            });

            // N-dash
            editor.addShortcut("ctrl+7", "N-dash", () => {
              editor.insertContent("\u2013");
            });

            // M-dash
            editor.addShortcut("ctrl+8", "M-dash", () => {
              editor.insertContent("\u2014");
            });

            // Minus
            editor.addShortcut("ctrl+9", "Minus", () => {
              editor.insertContent("\u2212");
            });

            // Em space
            editor.addShortcut("ctrl+0", "Em space", () => {
              editor.insertContent("\u2003");
            });

            // En space
            editor.addShortcut("alt++", "En space", () => {
              editor.insertContent("\u2002");
            });
            editor.addShortcut("alt+shift+r", "Go to Reference", () => {
              const elements = editor.dom.select("ref-list");

              if (elements.length > 0) {
                const el = elements[0];

                editor.selection.scrollIntoView(el);

                // editor.selection.select(el);
              }
            });
          },
        }}
      />


      <div className="bg-red">
      <Modal
        open={isCustomModalOpen}
        onCancel={() => setCustomModalOpen(false)}
        title="Styles"
        width={1000}
        footer={null}
        centered={true}
        bodyStyle={{ height: "70vh", overflow: "hidden", padding: 0,top:10 }}
        
      >
        <CustomstyleModel onApply={handleApplyStyles}
          onClose={() => setCustomModalOpen(false)} editor={editorInstance} />

      </Modal>
      </div>




      {config.FrontModal && (
        <FrontMatter
          show={showFrontMatter}
          handleCancel={handleCancel}
          editor={editor}
        />
      )}

      {showCitSupScript && config.FrontModal ? (
        <CitationtoSupScript
          visible={showCitSupScript}
          onClose={handleCitClose}
          editor={editor}
          editRef={editorRef}
        />
      ) : (
        <></>
      )}

      {/* MARK:modal for refrenceForm */}
      {(showReference?.add?.open || showReference?.edit?.open) &&
        config.FrontModal ? (
        <RefrenceForm
          handleCancel={handleCancel}
          editor={editor}
          show={showReference}
        />
      ) : (
        <></>
      )}

      {/*MARK: Modal for refrence swapping */}

      {showReference.swap.edit && (
        <SwapRefModal
          visible={showReference.swap.edit}
          onCancel={() =>
            setShowReference((prev) => ({
              ...prev,
              swap: {
                open: false,
                edit: false,
                id: null,
              },
            }))
          }
          onSwap={handleSwap}
        />
      )}
      {showDuplicate && config.FrontModal && (
        <DuplicateRefModal
          visible={showDuplicate}
          queryId={AllQueryId}
          onClose={handleDupRefCancel}
          editor={editor}
          duplicates={duplicateReference}
          setGenerateQuery={setGeneratedQuery}
        />
      )}

      {show && config.FrontModal ? (
        <Styling
          editor={editor}
          show={show}
          currentStyle={currentStyle}
          handleCancel={handleCancel}
          initialized={initialized}
        />
      ) : (
        <></>
      )}

      {showCitationModal ? (
        <Citationpopup
          show={showCitationModal}
          currentNode={currentNode}
          handleCancel={handleCancel}
          editor={editor}
        />
      ) : (
        <Citationpopup show={showCitationModal} />
      )}

      {/*MARK: Modal for citation deletion */}

      <Modal
        title="The Reference has citations would you like to delete it anyway?"
        open={showDelete}
        onOk={referenceDelete}
        maskClosable={false}
        onCancel={handleCancel}
        zIndex={10}
      ></Modal>

      {/* MARK: Modal for citation Editing */}

      {editCitationShow && (
        <HandleCitation
          node={currentNode}
          setShow={editCitationShow}
          handleCancel={handleCancel}
          editor={editor}
        />
      )}

      {/* MARK: Modal for Deleting Citation */}

      {deleteCitationShow && (
        <Modal
          title="Do you wish to delete the citation?"
          open={deleteCitationShow}
          onOk={deleteCitations}
          maskClosable={false}
          onCancel={handleCancel}
          zIndex={10}
        ></Modal>
      )}
      {addCitationShow && (
        <AddCitation
          editor={editor}
          handleCancel={handleCancel}
          setShow={addCitationShow}
        />
      )}

      {/* {showPopup && (
        <PopupModal
          editor={editor}
          setShowPopup={setShowPopup}
          handleQueryRef={handleQueryRef.current}
        />
      )} */}

      {config.treeView && (
        <button
          onClick={() => props.setShowNavBar(!props.showNavBar)}
          className="absolute h-6 w-6 border-[1px] border-[black] top-20 rounded-full z-10 flex items-center justify-center bg-white"
          style={{
            transform: props.showNavBar ? "rotate(0deg)" : "rotate(180deg)",
            left: props.showNavBar ? "-12px" : "-8px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-left"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M5 12l14 0" />
            <path d="M5 12l4 4" />
            <path d="M5 12l4 -4" />
          </svg>
        </button>
      )}

      {/* MARK: RightPanel Component */}
      <RightPanel
        editor={editor}
        isOpen={rightPanelOpen}
        panelValue={rightPanelvalue}
        onClose={RightPanelClose}
        setPanelOpen={setRightPanelOpen}
        setPanelValue={setRightPanelValue}
        setMetaValue={setMetaValue}
      >
        <Query
          isShow={rightPanelvalue}
          editor={editor}
          setShowQuery={setShowQuery}
          showQuery={showQuery}
          setShowPopup={setShowPopup}
          setQueryIds={setAllQueryId}
          ref={childDataRef}
        />

        <RightPanelRef
          editor={editor}
          isShow={rightPanelvalue}
          isOpen={rightPanelOpen}
          showRef={showReference}
        />

        {rightPanelvalue === "meta" && (
          <MetaData
            metaValue={metaValue}
            rightPanelvalue={rightPanelvalue}
            rightPanelOpen={rightPanelOpen}
            editor={editor}
            RightPanelClose={RightPanelClose}
            setShowFMatter={setShowFrontMatter}
          />
        )}
        {rightPanelvalue === "Custom styles" && (
          <SuggestionsData
            selectedStyles={selectedStyles}
            editor={editorInstance}

          />
        )}

        {rightPanelvalue === "pdf" && (
          <PdfViewer
            url={
              "https://www.aeee.in/wp-content/uploads/2020/08/Sample-pdf.pdf"
            }
          />
        )}

        {(showReference?.add?.open || showReference?.edit?.open) &&
          config.RightPanel ? (
          <PanelReferenceForm
            handleCancel={handleCancel}
            editor={editor}
            show={showReference}
          />
        ) : null}

        {showDuplicate && config.RightPanel && (
          <PanelDuplicateRef
            visible={showDuplicate}
            queryId={AllQueryId}
            onClose={handleCancel}
            editor={editor}
            duplicates={duplicateReference}
            setGenerateQuery={setGeneratedQuery}
          />
        )}

        {editShortCut && <EditorShortCuts onClose={handleCancel} />}

        {showCitSupScript && config.RightPanel ? (
          <SuperScript
            visible={showCitSupScript}
            onClose={handleCancel}
            editor={editor}
            editRef={editorRef}
          />
        ) : (
          <></>
        )}

        {show && config.RightPanel ? (
          <Styles
            editor={editor}
            show={show}
            currentStyle={currentStyle}
            handleCancel={handleCancel}
            initialized={initialized}
          />
        ) : (
          <></>
        )}
      </RightPanel>

      {/* MARK:Config modal */}
      <SettingsModal
        modalVisible={settingConfig}
        setModalVisible={setSettingConfig}
      />

      {/* MARK:Table Algorithm Modal */}

      {algorithmModal && (
        <AlgorithmModal
          editor={editor}
          setOpen={setAlgorithmModal}
          open={algorithmModal}
        />
      )}

      {/* MARK:FOOTNOTE MODAL */}
      {footNote.open && (
        <FootNoteModal editor={editor} note={footNote} setOpen={setFootNote} />
      )}

      {displayCitation.open && (
        <ShowCitation
          onClose={() => handleDisplayCitClose()}
          data={displayCitation}
        ></ShowCitation>
      )}
    </div>
  );
});

export default Tinyeditor;
